import React, { createContext } from "react"

const BreadCrumbsContext = createContext()

export default BreadCrumbsContext

export function BreadCrumbsProvider({ children }) {
  return <>{children}</>
}
